import DashView from './components/Dash.vue'
import NotFoundView from './components/404.vue'
import AuthPageView from './components/AuthPage.vue'

// Import Views - Dash
import DashboardView from './components/views/Dashboard.vue'
// import ServerView from './components/views/Server.vue'

// Routes
const routes = [
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: 'dashboard',
        alias: '',
        component: DashboardView,
        name: 'Dashboard',
        meta: {description: 'État des systèmes'}
      // }, {
      //   path: 'server',
      //   component: ServerView,
      //   name: 'Servers',
      //   meta: {description: 'List of our servers', requiresAuth: true}
      }
    ]
  }, {
    // Auth page handler
    path: '/AuthPage',
    component: AuthPageView
  }, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js